<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group label="Match data from:">
        <b-form-select v-model="selectedField" required>
          <option value="null" disabled>Please select an option</option>
          <option v-for="(field, fieldIndex) in dataEntryFields" :key="fieldIndex" :value="field">{{field.name}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group v-if="selectedField != null && selectedField.data_type === 'string'" label="Match if value:">
        <b-input-group>
          <b-form-select v-model="operator">
            <option value="null" disabled>Please select an option</option>
            <option value="starts">Starts with</option>
            <option value="equal">Is exactly</option>
          </b-form-select>
          <b-input v-model="value" maxlength="80"></b-input>
        </b-input-group>
      </b-form-group>
      <b-form-group v-if="selectedField != null && selectedField.data_type === 'numeric'" label="Match if value is:">
        <b-form-select v-model="operator">
          <option value="null" disabled>Please select an option</option>
          <option value="<">Less than</option>
          <option value="<=">Less than or equal to</option>
          <option value="=">Equal to</option>
          <option value=">=">Greater than or equal to</option>
          <option value=">">Greater than</option>
        </b-form-select>
      </b-form-group>
      <b-form-group v-if="selectedField != null && selectedField.data_type === 'numeric'">
        <b-input v-model="value"></b-input>
      </b-form-group>
      <b-form-group v-if="selectedField != null && selectedField.data_type === 'date'">
        <b-form-group id="start-date-label" label="Is on or after:" label-for="start-date">
          <date-picker id="start-date" v-model="rangeStart" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
        </b-form-group>
        <b-form-group id="end-date-label" label="And on or before:" label-for="end-date">
          <date-picker id="end-date" v-model="rangeEnd" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
        </b-form-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'DataEntryFilter',
  props: ['filter', 'dataEntryFields', 'disabled'],
  components: { DatePicker },
  data () {
    return {
      selectedField: this.dataEntryFields.find((f) => { return parseInt(this.filter.field_id) === f.id }) || null,
      summaryText: this.summaryTextForFilter(this.filter),
      operator: this.filter.operator || null,
      value: this.filter.value,
      rangeStart: (this.filter.range_start ? moment(this.filter.range_start, 'Y-M-D') : moment().subtract(1, 'months')),
      rangeEnd: (this.filter.range_end ? moment(this.filter.range_end, 'Y-M-D') : moment()),
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {},
  watch: {
    selectedField () {
      this.operator = null
      if (this.selectedField != null && this.selectedField.data_type === 'numeric') {
        this.value = '0'
      } else {
        this.value = ''
      }
    }
  },
  mounted () {
  },
  methods: {
    summaryTextForFilter (filter) {
      if (filter.operator != null) {
        const operatorString = {
          'starts': 'Starts',
          'equal': 'Is'
        }[filter.operator] || filter.operator
        return `${operatorString} ${filter.value}`
      } else if (this.filter.range_start != null && this.filter.range_end != null) {
        return `${moment(this.filter.range_start, 'Y-M-D').format('L')} - ${moment(this.filter.range_end, 'Y-M-D').format('L')}`
      } else {
        return 'None'
      }
    },
    validate () {
      this.isValid = true
      if (this.selectedField == null) {
        this.isValid = false
        this.errorMessage = 'Please select an item'
      } else if (this.selectedField.data_type === 'date') {
        if (this.rangeStart == null) {
          this.isValid = false
          this.errorMessage = 'Please select a start date'
        } else if (this.rangeEnd == null) {
          this.isValid = false
          this.errorMessage = 'Please select an end date'
        } else if (this.rangeStart >= this.rangeEnd) {
          this.isValid = false
          this.errorMessage = 'Start date must be before end date'
        }
      } else {
        if (this.operator == null) {
          this.isValid = false
          this.errorMessage = 'Please select a match type'
        } else if (this.value == null || this.value === '') {
          this.isValid = false
          this.errorMessage = 'Please enter a match value'
        } else if (this.selectedField.data_type === 'numeric' && isNaN(parseFloat(this.value))) {
          this.isValid = false
          this.errorMessage = 'Please enter a valid number'
        }
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.selectedField = this.dataEntryFields.find((f) => { return parseInt(this.filter.field_id) === f.id }) || null
      this.operator = this.filter.operator
      this.value = this.filter.value
      this.rangeStart = (this.filter.range_start ? moment(this.filter.range_start, 'Y-M-D') : moment().subtract(1, 'months'))
      this.rangeEnd = (this.filter.range_end ? moment(this.filter.range_end, 'Y-M-D') : moment())
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.filter.field_id = this.selectedField.id
      this.filter.name = this.selectedField.short_name
      if (this.selectedField.data_type === 'string' || this.selectedField.data_type === 'numeric') {
        this.filter.operator = this.operator
        this.filter.value = this.value
        delete this.filter.range_start
        delete this.filter.range_end
      } else {
        this.filter.range_start = moment(this.rangeStart).format('Y-M-D')
        this.filter.range_end = moment(this.rangeEnd).format('Y-M-D')
        delete this.filter.operator
        delete this.filter.value
      }
      this.summaryText = this.summaryTextForFilter(this.filter)
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/DataEntryFilter.vue